// extracted by mini-css-extract-plugin
export default {"moreOptionsContainer":"MoreOptions_moreOptionsContainer__jPYZf","moreOptions":"MoreOptions_moreOptions__HY0tS"};